module.exports = __webpack_public_path__ + "img/imple.7a97256.png";